import { get } from 'lodash'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'

const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES

export function block(store, campaignId) {
  const state = store.getState()
  const campaign = get(state, `campaign.${campaignId}`, {})
  if (campaign.campaign_type === CROWD_FUNDING) {
    return !(
      get(campaign, 'can_donate', true) && get(campaign, 'can_chip_in', true)
    )
  }
  return false
}
